import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import {loadLanguageAsync} from '../i18n/setup.js'
import {getLandingPageSettings} from '../scripts/settings.js'
import Landingpage from "../views/Landingpage.vue";
import Missing from '../views/404.vue';
import Home from '../views/Home.vue';


Vue.use(VueRouter)

const NOT_FOUND_LANGS = ['pl', 'en'];
const NOT_FOUND_DEFAULT_LANG = 'pl';

const routes = [
    {
        path: '/',
        redirect: '/pl'
    },
    {
        path: '/:lang([a-zA-Z]+)/404',
        name: "404",
        component: Missing,
        props: true,
        meta: {
            hasQueryParamPage: true,
        },
    },
    {
        // dawna strona krajowa z kafelkami wystaw — celowo niedostępna
        path: '/:lang([a-zA-Z]+)/:landingpage(poland|corporate)',
        redirect: to => `/${to.params.lang}/404`
    },
    {
        path: '/:lang([a-zA-Z]+)/:garden([a-zA-Z0-9\\-]+)',
        component: Landingpage,
        name: "LandingPage",
        props: true,
        meta: {
            hasQueryParamPage: true,
        },
    },
    {
        path: '/:lang([a-zA-Z]+)/:garden([a-zA-Z0-9\\-]+)/*',
        component: Landingpage,
        name: "LandingPage",
        props: true,
        meta: {
            hasQueryParamPage: true,
        },
    },
    {
        path: '/:lang([a-zA-Z]+)',
        name: 'Home',
        component: Home
    },
    {
        path: '*',
        redirect: '/pl/404'
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0
        if (to.hash && document.getElementById(to.hash)) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        } else {
            return;
        }

        return goTo(scrollTo)
    },
})

router.beforeEach((to, from, next) => {
    if (to.name === 'Home') {
        if (!['pl', 'en'].includes(to.params.lang)) {
            next('/pl');
            return;
        }
        loadLanguageAsync(to.params.lang).then(() => next());
        return;
    }
    if (to.name === '404') {
        // Strona 404 jest brandowa, nie zależy od konfiguracji żadnego ogrodu —
        // wystarczą globalne teksty dla obsługiwanego języka.
        const lang = NOT_FOUND_LANGS.includes(to.params.lang) ? to.params.lang : NOT_FOUND_DEFAULT_LANG;
        if (lang !== to.params.lang) {
            router.replace(`/${lang}/404`);
            return;
        }
        loadLanguageAsync(lang).then(() => next());
        return;
    }

    if (!(to.params.lang) && to.meta.language) {
        if(to.meta.site ==='corporate'){
            let userlang = navigator.language
                || navigator.userLanguage;
            if (sessionStorage.getItem('site-visited')) {
                to.params.lang = 'en';
            }else{
                sessionStorage.setItem('site-visited','true');
                if (userlang === 'pl' || userlang === 'pl-PL') {
                    router.push('/pl');
                    return;
                }
            }
        }
    }
    if (!(to.params.lang)) {
        router.push(`/${NOT_FOUND_DEFAULT_LANG}/404`)
        return;
    }

    if (to.params.garden) {
        getLandingPageSettings(to.params.garden).then((settings) => {
            if (settings && settings.enabled === false) {
                // landing wyłączony w konfiguracji — pokazujemy 404 i przerywamy nawigację
                // (brak return powodował, że mimo przekierowania wołane było next())
                router.replace(`/${to.params.lang}/404`);
                return;
            }
            if (!settings.languages.available.includes(to.params.lang)) {
                let path = to.fullPath.replace(to.params.lang, settings.languages.default);
                router.push(path);
                return;
            }
            loadLanguageAsync(to.params.lang, to.params.garden).then(() => next());
        }).catch((e) => {
            router.push(`/${NOT_FOUND_DEFAULT_LANG}/404`)
        });
    } else if (to.params.landingpage) {
        getLandingPageSettings(to.params.landingpage).then((settings) => {
            if (!settings.languages.available.includes(to.params.lang)) {
                let path = to.fullPath.replace(to.params.lang, settings.languages.default);
                router.push(path);
                return;
            }
            loadLanguageAsync(to.params.lang, to.params.landingpage).then(() => next());
        }).catch((e) => {
            router.push(`/${NOT_FOUND_DEFAULT_LANG}/404`)
        });
    } else {
        //corporate?
        getLandingPageSettings('corporate').then((settings) => {
            if (!settings.languages.available.includes(to.params.lang)) {
                let path = to.fullPath.replace(to.params.lang, settings.languages.default);
                router.push(path);
                return;
            }
            loadLanguageAsync(to.params.lang, 'corporate').then(() => next());
        }).catch((e) => {
            router.push(`/${NOT_FOUND_DEFAULT_LANG}/404`);
        });
    }

})

export default router
